export default __webpack_public_path__ + "static/premio-do-6cdac6dfa13c5232f0e32e98d30bfdab.png";